import React from 'react'
import { IconButton } from 'transfix-ui/components/IconButton'
import { Tooltip } from 'transfix-ui/components/Tooltip'
import { Link } from 'transfix-ui/core'
import { useUserDetails } from 'utils/hooks/useUserDetails'
import { IScraperJobConfigurationFragment } from 'apps/spot-quote-control-panel/graphql/ScraperJobConfigurationFragment'
import { formatTimeForBidderConfig } from 'apps/spot-quote-control-panel/utils/formatTimeForBidderConfig'
import { RightArrowIcon, OpenInNewTabIcon } from 'transfix-icons'
import { TableRow, TableCell } from 'transfix-ui'
import { ActiveJobRun } from './ActiveJobRun'
import { EnabledTag } from './EnabledTag'

interface ITmsTableRow {
  jobConfig: IScraperJobConfigurationFragment
  setFocusedJob: React.Dispatch<React.SetStateAction<IScraperJobConfigurationFragment | undefined>>
}

export const TmsTableRow = ({ jobConfig, setFocusedJob }: ITmsTableRow) => {
  const { userPermissions } = useUserDetails()
  const allowEdit = userPermissions?.canEditAutobidderConfigurations

  const lastExecutionStart = formatTimeForBidderConfig(
    jobConfig.scraperJobExecutionLastExecution?.startedAt
  )
  const lastExecutionEnd = formatTimeForBidderConfig(
    jobConfig.scraperJobExecutionLastExecution?.endedAt
  )

  const elementsWaitingTime = jobConfig.elementsWaitingTime
    ? `${jobConfig.elementsWaitingTime}s`
    : 'N/A'

  const demoMode = jobConfig.demoMode ? 'Demo' : 'Live'

  const openSidePanelHandler = () => {
    setFocusedJob(jobConfig)
  }

  const generateSqtLink = () => {
    const filters = encodeURIComponent(
      JSON.stringify({
        createdBy: ['autobidder'],
        shipperApplicationId: jobConfig.shipperApplication?.id,
        shipperApplicationName: jobConfig.shipperApplication?.name,
      })
    )

    return `${__ROOT__}/spot-quote-tool/search?filters=${filters}`
  }
  const sqtLink = generateSqtLink()

  return (
    <TableRow>
      <TableCell>{jobConfig.shipperApplication.name}</TableCell>
      <TableCell>{jobConfig.jobType}</TableCell>
      <TableCell>{jobConfig.description}</TableCell>
      <TableCell>
        <EnabledTag isEnabled={jobConfig.isEnabled} />
      </TableCell>
      <TableCell>{demoMode}</TableCell>
      <TableCell>{jobConfig.jobQueueName || 'N/A'}</TableCell>
      <TableCell>{elementsWaitingTime}</TableCell>
      <TableCell>{lastExecutionStart}</TableCell>
      <TableCell>{lastExecutionEnd}</TableCell>
      <TableCell>
        <ActiveJobRun
          activeJobRunStart={jobConfig.scraperJobExecutionCurrentExecution?.startedAt}
        />
      </TableCell>
      <TableCell>
        <Link target='_blank' rel='noopener noreferrer' href={sqtLink}>
          <OpenInNewTabIcon color='skyBlue6' size='xlarge' />
        </Link>
      </TableCell>
      <TableCell>
        <Tooltip
          position='top'
          trigger={
            <span>
              <IconButton
                disabled={!allowEdit}
                Icon={RightArrowIcon}
                onClick={openSidePanelHandler}
              />
            </span>
          }
          disable={allowEdit}>
          {allowEdit === false ? "You don't have edit permissions" : null}
        </Tooltip>
      </TableCell>
    </TableRow>
  )
}
